import {
  Badge,
  Card,
  CardHeader,
  CardHeaderTitle,
  Skeleton,
} from "@prismicio/editor-ui"
import type { ReactNode } from "react"

import { useSubscriptionQuery } from "../billing/useSubscription"

export function CurrentPlanCard() {
  const { data: subscription } = useSubscriptionQuery()
  return (
    <CurrentPlanCardTemplate
      badge={<Badge color="purple" title={subscription.nickname} />}
    />
  )
}

interface CurrentPlanCardTemplateProps {
  badge: ReactNode
}

function CurrentPlanCardTemplate(props: CurrentPlanCardTemplateProps) {
  const { badge } = props
  return (
    <Card
      color="purple2"
      paddingBlock={16}
      paddingInline={24}
      variant="outlined"
    >
      <CardHeader>
        <CardHeaderTitle variant="bold">Current plan</CardHeaderTitle>
        {badge}
      </CardHeader>
    </Card>
  )
}

export function CurrentPlanCardSkeleton() {
  return (
    <CurrentPlanCardTemplate
      badge={<Skeleton width={65} height={28} color="purple5" />}
    />
  )
}
